import { createWithEqualityFn } from 'zustand/traditional'
import { ExplanationsSlice, createExplanationsSlice } from '../store/slices/explanation'
import { AppsSlice, createAppsSlice } from './slices/apps'
import { AuthSlice, createAuthSlice } from './slices/auth'
import { createFieldsOfWorkSlice, FieldsOfWorkSlice } from './slices/fields_of_work'
import { createQuestionSlice, QuestionSlice } from './slices/question'
import { LanguagesSlice, createLanguagesSlice } from './slices/languages'
import { GlobalTranslationsSlice, createGlobalTranslationsSlice } from './slices/global_translations'
import { createQuizSlice, QuizSlice } from './slices/quiz'
import { ActiveQuestionSlice, createActiveQuestionSlice } from './slices/active_question'
import { ResultSlice, createResultSlice } from './slices/result'
import { buildQuestionTemplateSlice, QuestionTemplateSlice } from './slices/question_template'

export const useStore = createWithEqualityFn<
  ExplanationsSlice &
  AppsSlice &
  QuestionSlice &
  AuthSlice &
  FieldsOfWorkSlice &
  GlobalTranslationsSlice &
  LanguagesSlice &
  QuizSlice &
  ActiveQuestionSlice &
  ResultSlice &
  QuestionTemplateSlice
>()((...a) => ({
  ...createExplanationsSlice(...a),
  ...createAppsSlice(...a),
  ...createQuestionSlice(...a),
  ...createAuthSlice(...a),
  ...createFieldsOfWorkSlice(...a),
  ...createLanguagesSlice(...a),
  ...createGlobalTranslationsSlice(...a),
  ...createQuizSlice(...a),
  ...createActiveQuestionSlice(...a),
  ...createResultSlice(...a),
  ...buildQuestionTemplateSlice(...a)
}))
